import React, { ReactNode } from 'react';
import Box from '../Box/Box';
import filterConditionalKeyValues from '../../utils/filterConditionalKeyValues';

type TDeprecatedPrimaryButtonProps = {
  as?: 'a' | 'button';
  isDisabled?: boolean;
  href?: string;
  onClick?: () => void;
  tabIndex?: number;
  className?: string;
  children?: ReactNode;
};

const DeprecatedPrimaryButton = ({ as = 'button', isDisabled = false, ...rest }: TDeprecatedPrimaryButtonProps) => {
  const conditionalProps = filterConditionalKeyValues({
    states: isDisabled && 'disabled',
  });
  return (
    <Box {...rest} {...conditionalProps} name="Button" as={as} modifiers="deprecatedPrimary" disabled={isDisabled} />
  );
};

export default DeprecatedPrimaryButton;
